var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{staticClass:"modal-cont"},[_c('div',{staticClass:"overlay",on:{"click":_vm.back}}),_c('div',{staticClass:"limit"},[_c('transition',{attrs:{"name":"slide-fade-in","appear":""}},[_c('div',{staticClass:"modal"},[_vm._t("default")],2)])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3898a96","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/globals/ModalCont.vue
// module id = 405
// module chunks = 8